module.exports = __webpack_public_path__ + "img/solimgfour.081fb176.png";